import React, { useState } from "react";

interface PhoneFormStepProps {
  initialPhone?: string;
  onSubmit: (phone: string) => void;
  isLoading: boolean;
}

export const PhoneFormStep: React.FC<PhoneFormStepProps> = ({
  initialPhone = "",
  onSubmit,
  isLoading,
}) => {
  const [phone, setPhone] = useState(initialPhone.replace(/\D/g, "").slice(0, 10));
  const [error, setError] = useState<string | null>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Only accept digits, up to 10 digits
    const numericOnly = e.target.value.replace(/\D/g, "").slice(0, 10);
    setPhone(numericOnly);
    if (error) setError(null);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const clean = phone.replace(/\D/g, "");
    if (clean.length !== 10) {
      setError("El número de celular debe contener exactamente 10 dígitos.");
      return;
    }
    setError(null);
    onSubmit(clean);
  };

  return (
    <form id="phone-form-step" onSubmit={handleSubmit} className="space-y-6">
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-bold text-gray-900">Ingreso de Clientes</h2>
        <p className="text-sm text-gray-600">
          Ingresa tu número de teléfono móvil para consultar tus datos o iniciar el registro.
        </p>
      </div>

      <div>
        <label htmlFor="client-phone-input" className="block text-sm font-medium text-gray-700 mb-1">
          Número de Celular
        </label>
        <div className="relative rounded-md shadow-sm">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400 font-semibold">
            +57
          </div>
          <input
            id="client-phone-input"
            type="tel"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={10}
            value={phone}
            onChange={handleInputChange}
            placeholder="3001234567"
            disabled={isLoading}
            className="block w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg text-gray-900 focus:ring-blue-600 focus:border-blue-600 text-lg transition duration-150 disabled:bg-gray-100"
            autoFocus
            required
          />
        </div>
        <div className="flex justify-between items-center mt-1.5">
          {error ? (
            <p className="text-xs text-red-600">{error}</p>
          ) : (
            <p className="text-xs text-gray-400">10 dígitos numéricos</p>
          )}
          <span className="text-xs text-gray-400">{phone.length}/10</span>
        </div>
      </div>

      <button
        id="submit-phone-btn"
        type="submit"
        disabled={isLoading || phone.length !== 10}
        className="w-full flex items-center justify-center py-3.5 px-4 border border-transparent rounded-lg shadow-sm text-base font-semibold text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-150 disabled:opacity-50"
      >
        {isLoading ? (
          <span className="flex items-center space-x-2">
            <svg className="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
            </svg>
            <span>Buscando datos...</span>
          </span>
        ) : (
          "Continuar"
        )}
      </button>
    </form>
  );
};
